import type { CSSProperties } from 'react';
import { LabelSource, ModelType } from './types';

export const MODEL_TYPE_COLORS: Record<ModelType, CSSProperties> = {
  OD: {
    color: 'var(--blue)',
    background: 'rgba(200, 130, 80, 0.1)',
    border: '1px solid rgba(200, 130, 80, 0.3)',
  },
  VE: {
    color: 'var(--purple)',
    background: 'var(--purple-subtle)',
    border: '1px solid var(--purple-border)',
  },
  PC: {
    color: '#e09030',
    background: 'rgba(224, 144, 48, 0.1)',
    border: '1px solid rgba(224, 144, 48, 0.3)',
  },
  OOS: {
    color: 'var(--positive)',
    background: 'rgba(80, 200, 130, 0.1)',
    border: '1px solid rgba(80, 200, 130, 0.3)',
  },
};

export const ARCHIVED_STATUS_STYLES: Record<'active' | 'archived', CSSProperties> = {
  active: { color: 'var(--positive)', fontWeight: 600 },
  archived: { color: 'var(--text-tertiary)', fontWeight: 600 },
};

export const LABEL_SOURCE_STYLES: Record<LabelSource, CSSProperties> = {
  human: { color: 'var(--accent)', fontSize: 10, fontWeight: 600 },
  verified_inference: { color: 'var(--purple)', fontSize: 10, fontWeight: 600 },
};
